<script>
    import {Marker} from "vue2-google-maps";

    export default {
        extends: Marker,
        props: {
            draggable: {
                default: false,
            },
            clickable: {
                default: true,
            },
            options: {
                default: () => {
                    return {

                    }
                }
            }
        },
    }
</script>
